<template>
  <div class="assign-proxy-task flex flex-col">
    <!-- 提示信息 提示已选中那些人 -->
    <div class="content flex flex-col items-center justify-center">
      <div class="top-tips">
        <i class="el-icon-warning mx-2"></i>
        <span>已选中 {{ peopleName.slice(0, 3).join('、') }} 等共{{ peopleName.length }}个代理</span>
      </div>

      <!-- 任务信息 -->
      <div class="w-1/2 my-3 text-sm">任务信息：</div>

      <div class="form-content">
        <el-form ref="taskRuleForm" :label-position="labelPosition" label-width="140px" :model="formLabelAlign" :rules="rules">
          <el-form-item
            :style="{ marginBottom: formLabelAlign.settleMode ? '0' : '18px' }"
            label="结算方式："
            prop="settleMode"
            :rules="[{ required: true, message: ' ', trigger: 'change' }]"
          >
            <el-radio-group v-model="formLabelAlign.settleMode" @change="changeSettlementType">
              <el-radio :label="1">按答卷数量</el-radio>
              <el-radio :label="2">按天</el-radio>
              <el-radio :label="3">按阶梯计价</el-radio>
            </el-radio-group>
          </el-form-item>

          <div class="settlementType-style" style="margin: 16px 0" v-if="formLabelAlign.settleMode === 1">
            <div class="flex-box">
              <el-form-item
                label="单价（元）:"
                prop="settleRule.unitPriceYuan"
                :rules="[{ required: true, message: ' ', trigger: 'change' }]"
              >
                <el-input-number
                  placeholder=""
                  v-model="formLabelAlign.settleRule.unitPriceYuan"
                  autocomplete="off"
                  controls-position="right"
                  :min="1"
                  :max="Infinity"
                  :precision="2"
                >
                </el-input-number>
              </el-form-item>
              <span>元</span>
            </div>
            <div class="settlement-tips">
              若用线上结算，请填写调查员到手金额，到手金额
              <el-button type="text" @click="dialVisible = true">计算器</el-button>
            </div>
            <div class="flex-box">
              <span class="pos-abs-box">
                <i>*</i>
                答卷数量:
                <el-tooltip
                  effect="dark"
                  content="该数量仅为参考回收数量，调查员可超额上报答卷，您可与调查员线下协商上报数量，采用线上结算时，可按照实际上报答卷数量进行结算"
                  placement="top"
                >
                  <div class="icon-wrap" style="margin-left: 4px">
                    <span class="icon-font ico-tips" style="font-size: 12px">&#xe65b;</span>
                  </div>
                </el-tooltip>
              </span>
              <el-form-item
                label=""
                prop="settleRule.expectedQuantity"
                :rules="[{ required: true, message: ' ', trigger: 'change' }]"
              >
                <el-input-number
                  placeholder=""
                  v-model="formLabelAlign.settleRule.expectedQuantity"
                  autocomplete="off"
                  controls-position="right"
                  :min="1"
                  :max="Infinity"
                  :precision="0"
                >
                </el-input-number>
              </el-form-item>
              <span>份</span>
            </div>
            <div class="settlement-tips" style="margin-bottom: 0">
              预估费用：{{ totalPriceYuan }}元，若采用线上结算，项目预计花费 {{ totalSaleYuan }}元
            </div>
          </div>
          <div class="settlementType-style" style="margin: 16px 0" v-if="formLabelAlign.settleMode === 2">
            <div class="flex-box">
              <el-form-item
                label="单价（元）:"
                prop="settleRule.unitPriceYuan"
                :rules="[{ required: true, message: ' ', trigger: 'change' }]"
              >
                <el-input-number
                  placeholder=""
                  v-model.number="formLabelAlign.settleRule.unitPriceYuan"
                  autocomplete="off"
                  controls-position="right"
                  :min="1"
                  :max="Infinity"
                  :precision="2"
                >
                </el-input-number>
              </el-form-item>
              <span>元</span>
            </div>
            <div class="settlement-tips">
              若用线上结算，请填写调查员到手金额，到手金额
              <el-button type="text" @click="dialVisible = true">计算器</el-button>
            </div>
            <div class="flex-box">
              <span class="pos-abs-box">
                <i>*</i>
                天数:
                <el-tooltip
                  effect="dark"
                  content="当天只要上报答卷即记为工作 1 天，该天数仅为参考工作天数，您可与调查员线下协商工作天数，采用线上结算时，可按照实际工作天数进行结算"
                  placement="top"
                >
                  <div class="icon-wrap" style="margin-left: 4px">
                    <span class="icon-font ico-tips" style="font-size: 12px">&#xe65b;</span>
                  </div>
                </el-tooltip>
              </span>
              <el-form-item
                label=""
                prop="settleRule.expectedQuantity"
                :rules="[{ required: true, message: ' ', trigger: 'change' }]"
              >
                <el-input-number
                  placeholder=""
                  v-model.number="formLabelAlign.settleRule.expectedQuantity"
                  autocomplete="off"
                  controls-position="right"
                  :min="1"
                  :max="Infinity"
                  :precision="0"
                >
                </el-input-number>
              </el-form-item>
              <span>天</span>
            </div>
            <div class="settlement-tips" style="margin-bottom: 0">
              <div style="display: flex">
                <div>预估费用：{{ totalPriceYuan }}元，若采用线上结算，项目预计花费 {{ totalSaleYuan }}元</div>
                <el-tooltip
                  effect="dark"
                  :content="`项目预计费用=预估费用*（1+${accRate}），其中${accountingRateVal}为用于调查员待缴税及平台技术服务费`"
                  placement="top"
                >
                  <div class="icon-wrap">
                    <span class="icon-font ico-tips">&#xe65b;</span>
                  </div>
                </el-tooltip>
              </div>
            </div>
          </div>
          <div class="settlementType-style" style="margin: 16px 0" v-if="formLabelAlign.settleMode === 3">
            <el-form-item class="is-require-task" style="margin-bottom: 0" label="单价（元）:">
              <div
                class="flex-settlement"
                v-for="(item, index) in formLabelAlign.settleRule.tiers"
                :key="index"
                :style="{ marginBottom: index === formLabelAlign.settleRule.tiers.length - 1 ? '0px' : '5px' }"
              >
                <span style="margin-right: 8px" v-show="index === 0">每天</span>
                <el-form-item label>
                  <el-input-number
                    v-if="index === 0"
                    :disabled="true"
                    placeholder=""
                    v-model="item.quantityLowerBound"
                    autocomplete="off"
                    controls-position="right"
                    :min="0"
                    :max="Infinity"
                    :precision="0"
                  >
                  </el-input-number>
                  <el-input-number
                    v-if="index > 0"
                    :disabled="true"
                    placeholder=""
                    :value="formLabelAlign.settleRule.tiers[index - 1].quantityUpperBound"
                    autocomplete="off"
                    controls-position="right"
                    :min="0"
                    :max="Infinity"
                    :precision="0"
                  >
                  </el-input-number>
                </el-form-item>
                <span style="margin: 0 8px">份 &lt; 完成量 ≤</span>
                <el-form-item
                  label
                  :prop="'settleRule.tiers[' + index + '].quantityUpperBound'"
                  :rules="[{ required: true, message: ' ', trigger: 'change' }]"
                >
                  <el-input-number
                    placeholder=""
                    v-model="item.quantityUpperBound"
                    autocomplete="off"
                    controls-position="right"
                    :min="index > 0 ? formLabelAlign.settleRule.tiers[index - 1].quantityUpperBound * 1 + 1 : 1"
                    :max="Infinity"
                    @change="val => currentInputNumber(val, item, index)"
                    :precision="0"
                  >
                  </el-input-number>
                </el-form-item>
                <span style="margin: 0 8px">份，按完成量</span>
                <el-form-item
                  label
                  :prop="'settleRule.tiers[' + index + '].unitPriceYuan'"
                  :rules="[
                    {
                      required: true,
                      message: ' ',
                      trigger: 'change'
                    }
                  ]"
                  style="margin-left: 10px"
                >
                  <el-input-number
                    placeholder=""
                    v-model.number="item.unitPriceYuan"
                    autocomplete="off"
                    controls-position="right"
                    :min="1"
                    :max="Infinity"
                    :precision="2"
                  >
                  </el-input-number>
                </el-form-item>
                <span style="margin-left: 8px">元/份</span>
                <el-button v-if="index === 0" @click="handleSettlement('add', index)" class="btn-style" type="text"
                  ><i class="icon-font">&#xe68c;</i></el-button
                >
                <el-button
                  v-else-if="index === formLabelAlign.settleRule.tiers.length - 1"
                  @click="handleSettlement('remove', index)"
                  class="btn-style"
                  type="text"
                  ><i class="icon-font">&#xe68a;</i></el-button
                >
                <!-- <el-button @click="handleSettlement(index=== formLabelAlign.ladderSettlement.length-1 ? 'add' : 'remove')" class="btn-style" type="text"> {{index=== 0? '+':'-'}}</el-button> -->
              </div>
              <div class="settlement-tips left-0">
                若用线上结算，请填写调查员到手金额，到手金额
                <el-button type="text" @click="dialVisible = true">计算器</el-button>
              </div>
            </el-form-item>
            <div class="flex-box">
              <el-form-item
                style="margin-bottom: 0"
                label="天数:"
                prop="settleRule.expectedQuantity"
                :rules="[{ required: true, message: ' ', trigger: 'change' }]"
              >
                <el-input-number
                  placeholder=""
                  v-model.number="formLabelAlign.settleRule.expectedQuantity"
                  autocomplete="off"
                  controls-position="right"
                  :min="1"
                  :max="Infinity"
                  :precision="0"
                >
                </el-input-number>
              </el-form-item>
              <span>天</span>
            </div>
          </div>

          <el-form-item label="任务名称：" prop="taskName">
            <el-input v-model="formLabelAlign.taskName" style="width: 50%" placeholder="请输入任务名称"></el-input>
          </el-form-item>
          <el-form-item label="截止时间：" prop="endTime">
            <el-date-picker
              type="datetime"
              placeholder="选择时间"
              v-model="formLabelAlign.endTime"
              style="width: 50%"
              value-format="yyyy-MM-dd HH:mm:ss"
            ></el-date-picker>
            <!-- <el-input v-model="formLabelAlign.endTime"></el-input> -->
          </el-form-item>
          <!-- <el-form-item prop="count">
            <label slot="label"
              >答卷数量(个)
              <el-tooltip class="item" content="每名调查员需要完成的答卷数量" placement="top">
                <span class="el-icon-warning-outline"></span>
              </el-tooltip>
              ：</label
            >
            <el-input-number
              size="small"
              placeholder="请输入数量"
              v-model="formLabelAlign.count"
              :controls="true"
              :min="1"
            ></el-input-number>
          </el-form-item>
          <el-form-item prop="price">
            <label slot="label"
              >答卷单价(元)
              <el-tooltip content="“答卷单价”为回收答卷质控通过后调查员的到手金额" placement="top">
                <span class="el-icon-warning-outline"></span> </el-tooltip
              >：
            </label>
            <el-input-number
              size="small"
              placeholder="支持两位小数、支持0和正数"
              v-model="formLabelAlign.price"
              :min="0"
              :precision="2"
              :controls="true"
              :step="0.01"
            ></el-input-number>
          </el-form-item>
          <el-form-item label="预估费用：">
            <span>{{ aboutPrice }}元</span>
            <p class="inline-block ml-4" v-if="Number(GlobalConfig.getCompanyId())">
              推荐您通过调研工厂与调查员进行结算，为您节约成本
              <a class="text-blue cursor-pointer" @click="getMore">了解更多</a>
            </p>
          </el-form-item> -->
          <el-form-item label="描述：">
            <el-input placeholder="请输入内容" v-model="formLabelAlign.detail" style="width: 50%"></el-input>
          </el-form-item>
          <el-form-item label="执行要求：">
            <el-input placeholder="请输入内容" v-model="formLabelAlign.requirement"></el-input>
          </el-form-item>
          <el-form-item label="质控标准：">
            <el-input placeholder="请输入内容" v-model="formLabelAlign.qulityStandard"></el-input>
          </el-form-item>
          <el-form-item label="结算标准：">
            <el-input placeholder="请输入内容" v-model="formLabelAlign.checkoutStandard"></el-input>
          </el-form-item>
          <el-form-item label="代理是否审核答卷:">
            <el-switch v-model="formLabelAlign.agencyApproveFlag"></el-switch>
          </el-form-item>
        </el-form>
      </div>
    </div>

    <div class="self-end p-4" style="position: absolute; bottom: 0px">
      <el-button @click="back">取消</el-button>
      <el-button type="primary" @click="distributeTask">确认</el-button>
    </div>
    <OnlinePayService ref="onlinePayServiceVisible" />
    <over-mask
      :dialogVisible="dialVisible"
      @handleClose="
        () => {
          dialVisible = false
        }
      "
    ></over-mask>
  </div>
</template>

<script>
import { batchAddProxyTask } from '@/api/wenjuan/offline.js'
import OnlinePayService from '@/components/online-pay-service'
import OverMask from '@/views/survey/offline/components/overMask/OverMask.vue'
import GlobalConfig from '@/global/config'

export default {
  name: 'assignProxyTask',
  components: { OnlinePayService, OverMask },
  props: {
    data: {
      type: Map
    },
    title: {
      type: String,
      default: ''
    },
    id: {
      type: String
    }
  },
  data() {
    return {
      GlobalConfig,
      peopleName: [],
      labelPosition: 'right',
      formLabelAlign: {
        taskName: '',
        endTime: '',
        count: '',
        price: '',
        detail: '',
        requirement: '',
        qulityStandard: '',
        checkoutStandard: '',
        settleMode: '',
        settleRule: {
          unitPriceYuan: undefined, //单价 多少元/天  多少元/份
          expectedQuantity: undefined, // 数量 多少份 | 多少天
          tiers: [
            {
              quantityLowerBound: 0,
              quantityUpperBound: undefined,
              unitPriceYuan: undefined
            }
          ]
        },
        agencyApproveFlag: false
      },
      rules: {
        taskName: [{ required: true, message: '请输入任务名称', trigger: 'blur' }],
        endTime: [
          {
            type: 'string',
            required: true,
            message: '请选择截止时间',
            trigger: 'change'
          }
        ]
      },
      dialVisible: false
    }
  },
  methods: {
    back() {
      this.$emit('comeback')
    },
    // 分配任务
    distributeTask() {
      if (!this.formLabelAlign.taskName || !this.formLabelAlign.endTime) {
        this.$message.error('请将必填项填写完整！')
        return
      }
      this.$refs['taskRuleForm'].validate(valid => {
        if (valid) {
          // 处理阶梯计价开始数量
          let postData = {}
          if (this.formLabelAlign.settleMode === 3) {
            const cloneLadderSettlement = [...this.formLabelAlign.settleRule.tiers]
            cloneLadderSettlement.forEach((it, i, arr) => {
              if (i > 0) {
                it.quantityLowerBound = arr[i - 1].quantityUpperBound * 1
              }
            })
            postData = {
              ...this.formLabelAlign,
              agencyApproveFlag: this.formLabelAlign.agencyApproveFlag === true ? 1 : 0,
              settleRule: {
                ...this.formLabelAlign.settleRule,
                tiers: cloneLadderSettlement
              }
            }
            // postData.ladderSettlement =cloneLadderSettlement;
            this.formLabelAlign = { ...postData, agencyApproveFlag: this.formLabelAlign.agencyApproveFlag === true ? 1 : 0 }
          }
          let userList = []
          let params = []
          let commonParams = {
            surveyId: GlobalConfig.getSurveyId(),
            taskName: this.formLabelAlign.taskName,
            requireCount: this.formLabelAlign.count,
            unitPrice: this.formLabelAlign.price,
            endTime: this.formLabelAlign.endTime,
            description: this.formLabelAlign.detail || '',
            agencyApproveFlag: 1,
            executionRequirement: this.formLabelAlign.requirement || '',
            qualityControlStandard: this.formLabelAlign.qulityStandard || '',
            settleStandard: this.formLabelAlign.checkoutStandard || '',
            proxyJobId: Number(this.id) || '',
            settleMode: this.formLabelAlign.settleMode || '',
            settleRule: this.formLabelAlign.settleRule,
            agencyApproveFlag: this.formLabelAlign.agencyApproveFlag === true ? 1 : 0
          }
          console.log(this.data.values())
          for (let val of this.data.values()) {
            let temParam = Object.assign({}, commonParams)
            console.log(val, commonParams)
            temParam.agentId = val.id || val.agentId
            temParam.agentType = val.hasOwnProperty('type') ? val.type : val.agentType
            temParam.agentName = val.name || val.agentName
            temParam.relationId = val.relationId
            temParam.agentTenantId = val.agentTenantId
            temParam.phone = val.contact || val.phone
            params.push(temParam)

            userList.push({
              userId: val.userId,
              userName: val.interviewerName,
              phone: val.contact,
              justForCode: false
            })
          }
          batchAddProxyTask(params)
            .then(res => {
              this.$message.success('添加代理任务成功！')
              this.$emit('comeback')
            })
            .catch(e => {
              this.$message.error(`添加任务失败 ${e.message}`)
            })
        }
      })
    },
    // 监听input-number值的变化
    currentInputNumber(val, item, currentIndex) {
      const baseSettleRule = JSON.parse(JSON.stringify(this.formLabelAlign.settleRule))
      baseSettleRule.tiers.forEach((it, i, arr) => {
        if (i > currentIndex) {
          it.quantityUpperBound = arr[i - 1].quantityUpperBound + 1
        }
      })
      this.formLabelAlign.settleRule = {
        ...this.formLabelAlign.settleRule,
        tiers: baseSettleRule.tiers
      }
    },
    // 切换结算方式
    changeSettlementType(val) {
      this.$refs['taskRuleForm'].clearValidate()
      this.formLabelAlign = {
        ...this.formLabelAlign,
        settleMode: val,
        settleRule: {
          unitPriceYuan: undefined, //单价 多少元/天  多少元/份
          expectedQuantity: undefined, // 数量 多少份 | 多少天
          tiers: [
            {
              quantityLowerBound: 0,
              quantityUpperBound: undefined,
              unitPriceYuan: undefined
            }
          ]
        }
      }
    },
    handleSettlement(type, index) {
      if (type === 'add') {
        const validateArr = []
        this.formLabelAlign.settleRule.tiers.forEach((it, i) => {
          validateArr.push(`settleRule.tiers[${i}].quantityUpperBound`)
          validateArr.push(`settleRule.tiers[${i}].unitPriceYuan`)
        })
        let validFlag = false
        validateArr.forEach(item => {
          this.$refs['taskRuleForm'].validateField(
            validateArr,
            valid => (validFlag = valid ? false : true) // 定义是否通过表单验证
          )
        })
        if (validFlag) {
          if (this.formLabelAlign.settleRule.tiers.length < 5) {
            const lastTiers = this.formLabelAlign.settleRule.tiers[this.formLabelAlign.settleRule.tiers.length - 1]
            const lastObj = { quantityUpperBound: lastTiers.quantityUpperBound, unitPriceYuan: lastTiers.unitPriceYuan }

            const flagDouble = Object.values(lastObj).includes(undefined)
            if (flagDouble) {
              this.$message.error('请完善表单项')
              return
            }

            const cloneLadderSettlement = this.formLabelAlign.settleRule.tiers
            cloneLadderSettlement.push({
              quantityLowerBound: undefined,
              quantityUpperBound: undefined,
              unitPriceYuan: undefined
            })
            this.formLabelAlign.settleRule.tiers = cloneLadderSettlement
          } else {
            this.$message.error('最多只能添加5条数据')
          }
        } else {
          this.$message.error('请完善表单项')
        }
      } else if (type === 'remove') {
        const cloneLadderSettlement = this.formLabelAlign.settleRule.tiers

        this.formLabelAlign.settleRule.tiers = cloneLadderSettlement.filter((it, i) => index !== i)
      }
    },
    getMore() {
      this.$refs.onlinePayServiceVisible.openDialog()
    }
  },
  computed: {
    aboutPrice() {
      let result = ((this.formLabelAlign.count * 100 * this.formLabelAlign.price) / 100 || 0).toFixed(2)
      if (Number.isNaN(result)) return 0
      return result
    },
    totalPriceYuan () {
      if (this.formLabelAlign.settleRule.expectedQuantity && this.formLabelAlign.settleRule.unitPriceYuan) {
        return (this.formLabelAlign.settleRule.expectedQuantity * this.formLabelAlign.settleRule.unitPriceYuan).toFixed(2)
      } else {
        return 0
      }
    },
    totalSaleYuan () {
      if (this.formLabelAlign.settleRule.expectedQuantity && this.formLabelAlign.settleRule.unitPriceYuan) {
        return (
          (1 + this.accRate * 1) *
          (this.formLabelAlign.settleRule.expectedQuantity * this.formLabelAlign.settleRule.unitPriceYuan)
        ).toFixed(2)
      } else {
        return 0
      }
    },
    accountingRateVal() {
      const { accountingRate = 0 } = this.$store.getters || {};
      return accountingRate === null || accountingRate === 0 ? '6.5%' : `${accountingRate}%`
    },
    accRate() {
      const { accountingRate = 0 } = this.$store.getters || {};
      return accountingRate === null || accountingRate === 0 ? '0.065' : (accountingRate / 100).toFixed(3)
    }
  },
  created() {
    // 如果传入了招募任务的标题
    if (this.title) {
      this.formLabelAlign.taskName = this.title
    }

    for (let val of this.data.values()) {
      if (val.hasOwnProperty('name')) {
        this.peopleName.push(val.name)
      } else if (val.hasOwnProperty('agentName')) {
        this.peopleName.push(val.agentName)
      }
    }
  },
  beforeDestroy() {
    this.formLabelAlign.taskName = ''
  }
}
</script>

<style lang="scss" scoped>
.assign-proxy-task {
  .content {
    .top-tips {
      width: 65%;
      background-color: #e6f7ff;
      border: 1px solid #a6ddff;
      padding: 3px;
      .el-icon-warning {
        color: #1890ff;
      }
    }
  }
  .form-content {
    width: 65%;
    .settlementType-style {
      .is-require-task {
        .el-form-item__label {
          &::before {
            content: '*';
            color: #e34152;
            margin-right: 4px;
          }
        }
      }
      .flex-box {
        display: flex;
        position: relative;
        .pos-abs-box {
          position: absolute;
          display: flex;
          justify-content: flex-end;
          width: 128px;
          padding-right: 12px;
          i {
            content: '*';
            color: #e34152;
            margin-right: 4px;
          }
        }
        & > span {
          line-height: 32px;
          margin-left: 8px;
          color: rgba(0, 0, 0, 0.65);
          font-size: 14px;
          font-weight: 400;
          font-family: PingFangSC-Regular;
        }
      }
      margin-bottom: 16px;
      padding: 12px;
      background-color: rgba(242, 242, 242, 0.624);
      .el-form-item {
        margin-bottom: 18px;
        .el-input-number {
          width: 88px;
          background: #f2f5fa;
          .el-input__inner {
            padding-left: 5px !important;
            padding-right: 25px !important;
          }
        }
        .el-input-number.is-controls-right .el-input__inner {
          background: #f2f5fa;
        }
        .el-input.is-disabled .el-input__inner {
          border-color: rgba(221, 221, 221, 1);
        }
        .el-input-number__decrease,
        .el-input-number__increase {
          background: #f2f5fa;
          .el-icon-arrow-down,
          .el-icon-arrow-up {
            color: rgba(0, 0, 0, 0.65);
            border-color: rgba(221, 221, 221, var(--tw-border-opacity));
          }
        }
      }
      .btn-style {
        margin-left: 5px;
      }
      .settlement-tips {
        margin-left: 100px;
        font-size: 12px;
        margin-bottom: 8px;
        font-family: PingFangSC-Regular;
        font-weight: 400;
        font-size: 12px;
        color: rgba(0, 0, 0, 0.65);
        .el-button {
          font-size: 12px;
        }
        &.left-0 {
          margin-left: 0;
          margin-bottom: 0;
        }
      }
      .flex-settlement {
        display: flex;
        margin-bottom: 5px;
        align-items: center;
        .settlement-tips {
          margin-bottom: 0;
        }
        .el-form-item {
          margin-bottom: 0;
        }
        .el-input-number {
          width: 88px;
          background: #f2f5fa;
        }
        span {
          font-family: PingFangSC-Regular;
          font-weight: 400;
          font-size: 14px;
          color: rgba(0, 0, 0, 0.65);
        }
        &:last-child {
          margin-bottom: 0;
        }
      }
    }
  }
  .el-form-item--mini.el-form-item,
  .el-form-item--small.el-form-item {
    margin-bottom: 18px;
  }
}
</style>
